import React from 'react';
import { Admin, Resource } from 'react-admin';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import {
  createDataProvider,
  authProvider,
  LoginPage,
  LogoutButton,
  CallbackPage,
} from './ReactAdminOss._Core/src';
import createAdminStore from './reduxStore';
import { templateResources, microservices, customRoutes, customReducers } from './AppSettings';
import { Tasks } from './Tasks';
import OssLayout from './layout/OssLayout';
import theme from './layout/theme';
import { Snackbar } from './Tasks/components';
import { AppFeatures } from './AppFeatures';

export default () => {
  // използва имената в ресурс и микросервиз обектите за да ни създаде
  const map = (resources, microservicesObj) => {
    const mapping = {};
    for (let i = 0; i < resources.length; i++) {
      const nameSplit = resources[i].name.split('-');
      const microserviceName = nameSplit[0];
      const controllerName = nameSplit[1];

      if (microservicesObj) {
        mapping[controllerName] = microservicesObj[microserviceName];
      }
    }
    return mapping;
  };
  // (https://marmelab.com/react-admin/doc/3.2/DataProviders.html)
  // всичко автоматични заявки от react admin минават през dataProveder и за да знаят кой микосервиза на кое url да търсят създаваме следния обект
  const dataProvider = createDataProvider(map(templateResources, microservices));
  // за създаване на history обект (https://github.com/ReactTraining/history)
  // когато приложението се качи на линукс машините, то се достъпва на domain/appBaseName/ за разлика от локално където е domain:port/
  const history = createBrowserHistory({ basename: process.env.REACT_APP_BASENAME });
  // позволява използването на redux devtools, което е желателно при разработка и нежелателно на продукционна
  const useReduxTools = process.env.REACT_APP_REDUX_TOOL_ENABLED;
  const store = createAdminStore(history, dataProvider, useReduxTools, customReducers);
  // higher order component който дава референция на нашия redux store и history object от които се нуждаят компонентите от core пакета
  const ContextWrapper = component =>
    React.createElement(component, { context: React.createContext(store), history });
  // ползва се при автентикация
  const baseRoutes = [
    <Route exact path="/callback" component={() => ContextWrapper(CallbackPage)} />,
  ];
  // функцията която създава реакт админ ресурсите от масива с обекти
  // взима само втората част от името за да има по културни име на страниците и адресите(route)
  const mapResources = templateResources.map(x => (
    <Resource key={x.name} {...{ ...x, name: x.name.split('-')[1] }} />
  ));

  return (
    <Provider store={store}>
      <Snackbar />
      <AppFeatures />
      <Admin
        title="Error"
        authProvider={authProvider}
        dataProvider={dataProvider}
        theme={theme}
        loginPage={() => ContextWrapper(LoginPage)}
        logoutButton={() => ContextWrapper(LogoutButton)}
        layout={OssLayout}
        history={history}
        customRoutes={customRoutes ? [...baseRoutes, ...customRoutes] : baseRoutes}
        dashboard={Tasks}
      >
        {mapResources}
      </Admin>
    </Provider>
  );
};
